export default __webpack_public_path__ + "static/media/student-cert.e2bda430.jpg";